export function assertNever(_x: never): never {
  throw new Error('Oops, TypeScript did not catch this logic error')
}
